import React, { Component } from 'react';
import MenuAppBar from './MenuAppBar';
import CustomJumbotron from './custom_jumbotron'

export default class Layout extends Component {
  render() {
    const { user, iconePath, alt, content } = this.props
    return (
     // Link para quando o sistema estiver fora do ar 
     // window.location = "https://csig1g-prd-protheus.totvscloud.com.br:12021/pp/"
      <div>
        <MenuAppBar
          user={user}
        />
        <div id='fixed-top-bar' />
        <CustomJumbotron
          content={content}
          iconePath={iconePath}
          alt={alt}
         
        />
       
      </div>
      
    )
  }
}